import { useFeature } from "byzantine";

/**
 * Hook to check if card linked offers feature is enabled
 * @returns Boolean indicating if the card_linked_offers feature flag is enabled
 */
const useCardLinkedOffersFeature = (): boolean => {
  const { featureEnabled } = useFeature();
  return featureEnabled("card_linked_offers");
};

export default useCardLinkedOffersFeature;
